import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import TigerLogo from "@/components/TigerLogo";

export default function InfoPage() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/info").then((r) => setInfo(r.data)); }, []);

  return (
    <div>
      <div className="border-b border-slate-200 bg-white px-6 py-4">
        <div className="font-heading text-xl font-semibold">Informazioni</div>
      </div>
      <div className="p-6 max-w-3xl space-y-4">
        <div className="bg-white border border-slate-200 rounded-md p-6 flex items-center gap-6">
          <TigerLogo size={96} className="shadow-lg shadow-orange-500/20" />
          <div>
            <div className="font-heading text-2xl font-semibold">@Tiger Professional</div>
            <div className="text-sm text-slate-500 mt-1">Versione iniziale: <span className="font-mono">{info?.version || "—"}</span></div>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-6">
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">Disclaimer</div>
          <p className="text-sm leading-relaxed text-slate-700">{info?.disclaimer}</p>
        </div>
        <div className="bg-slate-50 border border-slate-200 rounded-md p-6 text-sm text-slate-600 space-y-2">
          <p><span className="font-semibold text-slate-800">Motore decisionale:</span> deterministico, basato esclusivamente sulle regole configurate. Nessun modello generativo determina autonomamente il codice.</p>
          <p><span className="font-semibold text-slate-800">Versionamento clinico:</span> ogni triage registra la versione del protocollo utilizzato. Modifiche successive al protocollo non alterano retroattivamente i triage già chiusi.</p>
          <p><span className="font-semibold text-slate-800">Firma:</span> l'architettura è predisposta per una futura firma digitale del report. Nessuna firma legalmente qualificata è simulata.</p>
        </div>
      </div>
    </div>
  );
}
